import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/logo.svg'
import _imports_1 from '@/assets/mark.svg'


const _hoisted_1 = { class: "hello" }
const _hoisted_2 = { class: "homeCards" }

import Card from 'primevue/card';
import 'primeicons/primeicons.css';

const __default__ = {
  name: "HomePage",
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[24] || (_cache[24] = _createElementVNode("section", { class: "hero" }, [
      _createElementVNode("h1", { class: "sr-only" }, "Dragonfly Massage — Massage Therapy in Springfield, MO"),
      _createElementVNode("img", {
        src: _imports_0,
        alt: "Dragonfly Massage"
      }),
      _createElementVNode("p", null, "Every body is unique and worthy of special treatment."),
      _createElementVNode("a", {
        class: "book-button",
        target: "_blank",
        rel: "noopener",
        href: "https://calendly.com/cj-dragonflymassage"
      }, "Book Now")
    ], -1)),
    _createVNode(_component_router_link, {
      to: "/gift-cards",
      class: "gift-banner"
    }, {
      default: _withCtx(() => _cache[0] || (_cache[0] = [
        _createElementVNode("i", {
          class: "pi pi-gift",
          "aria-hidden": "true"
        }, null, -1),
        _createTextVNode(" Give the Gift of Relief: Holiday Gift Cards ")
      ])),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _cache[23] || (_cache[23] = _createElementVNode("div", { class: "dragonfly-divider" }, [
        _createElementVNode("img", {
          src: _imports_1,
          alt: ""
        })
      ], -1)),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(Card), { class: "homeCard" }, {
          header: _withCtx(() => _cache[1] || (_cache[1] = [
            _createElementVNode("i", {
              class: "pi pi-heart card-icon",
              "aria-hidden": "true"
            }, null, -1)
          ])),
          title: _withCtx(() => _cache[2] || (_cache[2] = [
            _createTextVNode("Welcome")
          ])),
          subtitle: _withCtx(() => _cache[3] || (_cache[3] = [
            _createTextVNode("Every body is unique and worthy of special treatment!")
          ])),
          content: _withCtx(() => _cache[4] || (_cache[4] = [
            _createElementVNode("p", null, " Dragonfly Massage is the practice of CJ Berkstresser, a Licensed Massage Therapist (LMT) in Springfield, MO. Whether you are looking to unwind, recover, or simply be cared for, each session is tailored to you and your ever-changing body. ", -1),
            _createElementVNode("p", null, " The dragonfly is our symbol of healing, hope, and endurance. We would love to help you feel your best. ", -1)
          ])),
          _: 1
        }),
        _createVNode(_unref(Card), { class: "homeCard" }, {
          header: _withCtx(() => _cache[5] || (_cache[5] = [
            _createElementVNode("i", {
              class: "pi pi-list card-icon",
              "aria-hidden": "true"
            }, null, -1)
          ])),
          title: _withCtx(() => _cache[6] || (_cache[6] = [
            _createTextVNode("What We Offer")
          ])),
          content: _withCtx(() => [
            _cache[19] || (_cache[19] = _createElementVNode("p", null, "Customized massage, built around what your body needs:", -1)),
            _createElementVNode("ul", null, [
              _cache[8] || (_cache[8] = _createElementVNode("li", null, "Swedish (Relaxation) Massage", -1)),
              _cache[9] || (_cache[9] = _createElementVNode("li", null, "Deep Tissue & Trigger Point Therapy", -1)),
              _cache[10] || (_cache[10] = _createElementVNode("li", null, "Manual Lymphatic Drainage (MLD)", -1)),
              _cache[11] || (_cache[11] = _createElementVNode("li", null, "Prenatal Massage", -1)),
              _cache[12] || (_cache[12] = _createElementVNode("li", null, "Kinetic Stretching & Table Thai", -1)),
              _cache[13] || (_cache[13] = _createElementVNode("li", null, "Combo & Kinetic / Relaxation Split sessions", -1)),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, { to: "/corporate" }, {
                  default: _withCtx(() => _cache[7] || (_cache[7] = [
                    _createTextVNode("Corporate & Workplace Massage")
                  ])),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("p", null, [
              _cache[16] || (_cache[16] = _createTextVNode(" See the ")),
              _createVNode(_component_router_link, { to: "/services" }, {
                default: _withCtx(() => _cache[14] || (_cache[14] = [
                  _createTextVNode("Services")
                ])),
                _: 1
              }),
              _cache[17] || (_cache[17] = _createTextVNode(" and ")),
              _createVNode(_component_router_link, { to: "/pricing" }, {
                default: _withCtx(() => _cache[15] || (_cache[15] = [
                  _createTextVNode("Pricing")
                ])),
                _: 1
              }),
              _cache[18] || (_cache[18] = _createTextVNode(" pages for details. "))
            ])
          ]),
          _: 1
        }),
        _createVNode(_unref(Card), { class: "homeCard" }, {
          header: _withCtx(() => _cache[20] || (_cache[20] = [
            _createElementVNode("i", {
              class: "pi pi-calendar card-icon",
              "aria-hidden": "true"
            }, null, -1)
          ])),
          title: _withCtx(() => _cache[21] || (_cache[21] = [
            _createTextVNode("Book & Contact")
          ])),
          content: _withCtx(() => _cache[22] || (_cache[22] = [
            _createElementVNode("p", null, "Book online at either location:", -1),
            _createElementVNode("p", null, [
              _createElementVNode("b", null, "Main Location — Dragonfly Massage"),
              _createElementVNode("br"),
              _createTextVNode(" Suite 32, Sola Salon Studios"),
              _createElementVNode("br"),
              _createTextVNode(" 1839-B E Independence St"),
              _createElementVNode("br"),
              _createTextVNode(" Springfield, MO 65804 ")
            ], -1),
            _createElementVNode("p", null, [
              _createElementVNode("a", {
                class: "book-button",
                target: "_blank",
                rel: "noopener",
                href: "https://calendly.com/cj-dragonflymassage"
              }, "Book at Main Location")
            ], -1),
            _createElementVNode("p", null, [
              _createElementVNode("b", null, "Partner Location — Counter Negative"),
              _createElementVNode("br"),
              _createTextVNode(" 3800 S Fremont Ave"),
              _createElementVNode("br"),
              _createTextVNode(" Springfield, MO 65804 ")
            ], -1),
            _createElementVNode("p", null, [
              _createElementVNode("a", {
                class: "book-button",
                target: "_blank",
                rel: "noopener",
                href: "https://www.counternegative.com/book-now"
              }, "Book at Counter Negative")
            ], -1),
            _createElementVNode("p", null, "Prefer to reach out directly? Contact CJ:", -1),
            _createElementVNode("ul", null, [
              _createElementVNode("li", null, [
                _createElementVNode("a", { href: "tel:417-929-2533" }, "417-929-2533")
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", { href: "mailto:cj.dragonflymassage@gmail.com" }, "cj.dragonflymassage@gmail.com")
              ])
            ], -1),
            _createElementVNode("p", null, [
              _createTextVNode(" Follow Dragonfly Massage on "),
              _createElementVNode("a", {
                target: "_blank",
                rel: "noopener",
                href: "https://www.facebook.com/DragonflyMassageSGF"
              }, "Facebook"),
              _createTextVNode(", and Counter Negative on "),
              _createElementVNode("a", {
                target: "_blank",
                rel: "noopener",
                href: "https://www.facebook.com/counternegativerecoveryandwellness"
              }, "Facebook"),
              _createTextVNode(". ")
            ], -1),
            _createElementVNode("i", null, "Wishing you wellness!", -1)
          ])),
          _: 1
        })
      ])
    ])
  ]))
}
}

})